{
  "addons.addonList": "Eklenti Listesi",
  "addons.ambientWeatherCreateAndRetrieveApiKey": "Bu bağlantıdan API anahtarınızı oluşturun ve alın",
  "addons.ambientWeatherDescription": "Ortam Hava İstasyonları (WS-5000, WS-2000, WS-2902C, ...)",
  "addons.apiKey": "API Anahtarı",
  "addons.applicationKey": "Uygulama anahtarı",
  "addons.connect": "Bağlan",
  "addons.davisApiSecret": "API sırrı",
  "addons.davisApiV2Key": "V2 API Anahtarı",
  "addons.davisDescription": "Davis Hava Durumu İstasyonları (Vantage Vue, Vantage Pro2, ...)",
  "addons.davisRetrieveApiKey": "V2 API anahtarlarınızı bu bağlantıdan alın",
  "addons.disconnect": "Bağlantıyı kes",
  "addons.ecowittCreateAndRetrieveKeys": "Bu bağlantıdan hem API anahtarı hem de bir uygulama anahtarı oluşturun ve alın",
  "addons.ecowittDescription": "Ecowitt, profesyonel WiFi hava durumu istasyonu, kablosuz kapalı dış mekan termometreleri, nem monitörleri, yüksek hassasiyetli yağmur göstergeleri, hava kalitesi monitörleri ve daha fazlasını sağlar.",
  "addons.helpLink": "{provider} nasıl bağlanır",
  "addons.myAcuriteAccountOnHold": "Hesabınız beklemeye alındı. Hesabınızı yeniden bağlamak için lütfen şifrenizi girin",
  "addons.myAcuriteDescription": "Acurite, Kuzey Amerika'daki 1 numaralı hava istasyonu markasıdır. Zaman, sıcaklık ve hava teknolojisinde bir lider olarak Acurite, iç mekan ve dış ortamınız hakkında ayrıntılı bilgi sağlar, böylece gününüzü güvenle planlayabilirsiniz.",
  "addons.myAcuriteEnterCredentials": "Acurite hesabımı SmartMixin ile bağlamak için Acurite kimlik bilgilerinizi girin",
  "addons.netatmoEnergy": "Netatmo enerjisi",
  "addons.netatmoEnergyDescription": "Evinizin sıcaklığını, yatağınızdan veya dünyanın diğer tarafından değiştirmek için netatmo termostatınızı kullanın.",
  "addons.netatmoThermostat": "Netatmo termostat",
  "addons.netatmoWeather": "Netatmo hava durumu",
  "addons.netatmoWeatherDescription": "Evde kişisel hava istasyonunuz",
  "addons.or": "veya",
  "addons.providerAccountDisconnected": "Hava durumu hizmetinize olan bağlantı süresi doldu. Veri güncellemelerini sürdürmek için lütfen yeniden bağlanın.",
  "addons.reconnect": "Yeniden bağlan",
  "addons.weatherflowCreateToken": "Bu bağlantıdan jetonunuzu oluşturun ve alın",
  "addons.weatherflowTempestDescription": "Dahili rüzgar ölçer, yağmur göstergesi ile tempest hava sistemi",
  "addons.wundergroundApiKey": "API Anahtarı",
  "addons.wundergroundDescription": "Weather Underground, hava istasyonları ve hava kalitesi monitörleri gibi çevre sensörlerinden veri birleştiren küresel bir insan topluluğudur, böylece tutkularınızı güçlendirmek için ihtiyacınız olan zengin, hiperlokal verileri sağlayabiliriz",
  "addons.wundergroundRetrieveApiKey": "API anahtarınızı bu bağlantıdan alın",
  "addons.wundergroundRetrieveStationId": "İstasyon Kimliğinizi bu bağlantıdan alın",
  "addons.wundergroundStationId": "İstasyon kimliği",
  "airQuality.airQuality": "Hava kalitesi",
  "airQuality.airQualityIndex": "Hava Kalitesi Endeksi",
  "airQuality.aqiForecast": "Hava kalitesi tahmini",
  "airQuality.co": "Karbon monoksit",
  "airQuality.dailyForecast": "Günlük Tahmin",
  "airQuality.details": "Detaylar",
  "airQuality.dominantPollutant": "Baskın kirletici",
  "airQuality.good": "İyi",
  "airQuality.goodDescription": "Hava kalitesi tatmin edici olarak kabul edilir ve hava kirliliği çok az risk oluşturur veya hiç yoktur",
  "airQuality.hazardous": "Tehlikeli",
  "airQuality.hazardousDescription": "Sağlık Uyarısı: Herkes daha ciddi sağlık etkileri yaşayabilir",
  "airQuality.indoorAirQuality": "İç Mekan Hava Kalitesi",
  "airQuality.mgm3": "mg/m³",
  "airQuality.moderate": "Ilıman",
  "airQuality.moderateDescription": "Hava kalitesi kabul edilebilir; Bununla birlikte, bazı kirleticiler için, hava kirliliğine alışılmadık derecede duyarlı olan çok az sayıda insan için ılımlı bir sağlık sorunu olabilir.",
  "airQuality.no2": "Azot dioksit",
  "airQuality.o3": "Ozon",
  "airQuality.pm10": "Çapı 10 μm veya daha az olan parçacıklar",
  "airQuality.pm25": "Çapı 2.5 μm veya daha az olan parçacıklar",
  "airQuality.ppb": "ppb",
  "airQuality.sensitiveUnhealthy": "Hassas insanlar için sağlıksız",
  "airQuality.sensitiveUnhealthyDescription": "Hassas grupların üyeleri sağlık etkileri yaşayabilir. Genel halkın etkilenmesi muhtemel değildir.",
  "airQuality.so2": "Kükürt dioksit",
  "airQuality.ugm3": "µg/m³",
  "airQuality.unhealthy": "Sağlıksız",
  "airQuality.unhealthyDescription": "Herkes sağlık etkileri yaşamaya başlayabilir; Hassas grupların üyeleri daha ciddi sağlık etkileri yaşayabilir",
  "airQuality.veryUnhealthy": "Çok sağlıksız",
  "airQuality.veryUnhealthyDezscription": "Acil durum koşullarının sağlık uyarıları. Tüm nüfusun etkilenmesi daha olasıdır.",
  "alerts.addAlert": "Uyarı Ekle",
  "alerts.addCondition": "Durum ekle",
  "alerts.alertAdded": "Uyarı başarıyla eklendi",
  "alerts.alertAuthorizationNotice": "Uyarılar yalnızca SmartMixin'e bildirimleri görüntüleme yetkisi verirseniz çalışır",
  "alerts.alertDeleted": "Uyarı başarıyla silindi",
  "alerts.alertEdited": "Uyarı başarıyla değiştirildi",
  "alerts.alertName": "Uyarı Adı",
  "alerts.alertWhen": "Ne zaman uyarılmak istiyorum:",
  "alerts.aqiGreaterThan": "AQI daha büyük",
  "alerts.aqiGreaterThanThreshold": "AQI {value}{unit} eşiğinden daha büyük",
  "alerts.aqiLessThan": "AQI daha az",
  "alerts.aqiLessThanThreshold": "AQI {value}{unit} eşiğinden daha az",
  "alerts.atLeastOneCondition": "En az bir durum eklemeniz gerekiyor",
  "alerts.co2GreaterThan": "CO2 daha büyük",
  "alerts.co2GreaterThanThreshold": "CO2 {value}{unit} eşiğinden daha büyük",
  "alerts.co2LessThan": "CO2 daha az",
  "alerts.co2LessThanThreshold": "CO2 {value}{unit} eşiğinden daha az",
  "alerts.conditions": "Koşullar",
  "alerts.createAlert": "Uyarı Oluştur",
  "alerts.dailyPrecipitationGreaterThan": "Günlük yağış şundan fazla",
  "alerts.dailyPrecipitationGreaterThanThreshold": "Günlük yağış {value}{unit} eşiğini aştı",
  "alerts.deleteAlert": "Uyarıyı sil",
  "alerts.editAlert": "Uyarı düzenle",
  "alerts.editCondition": "Düzenleme Durum",
  "alerts.gustSpeedGreaterThan": "Rüzgar hamlesi hızı daha büyük",
  "alerts.gustSpeedGreaterThanThreshold": "Rüzgar hamlesi hızı {value}{unit} eşiğinden daha büyük",
  "alerts.gustSpeedLessThan": "Rüzgar hamlesi hızı daha az",
  "alerts.gustSpeedLessThanThreshold": "Rüzgar hamlesi hızı {value}{unit} eşiğinden daha az",
  "alerts.heatIndexGreaterThan": "Isı indeksi daha büyük",
  "alerts.heatIndexGreaterThanThreshold": "{value}{unit} eşiğinden büyük Isı indeksi",
  "alerts.heatIndexLessThan": "Isı indeksi daha az",
  "alerts.heatIndexLessThanThreshold": "{value}{unit} eşiğinden daha az Isı indeksi",
  "alerts.humidexGreaterThan": "Humidex daha büyük",
  "alerts.humidexGreaterThanThreshold": "{value}{unit} eşiğinden büyük Humidex",
  "alerts.humidexLessThan": "Humidex daha az",
  "alerts.humidexLessThanThreshold": "{value}{unit} eşiğinden daha az Humidex",
  "alerts.humidityGreaterThan": "Nemden daha büyük",
  "alerts.humidityGreaterThanThreshold": "Nem {value}{unit} eşiğinden daha büyük",
  "alerts.humidityLessThan": "Nemden daha az",
  "alerts.humidityLessThanThreshold": "Nem {value}{unit} eşiğinden daha az",
  "alerts.inProgress": "Devam etmekte",
  "alerts.myAlerts": "Uyarılarım",
  "alerts.noConfiguredAlert": "Henüz yapılandırılmış herhangi bir uyarınız yok, bir tane eklemeye başlayın",
  "alerts.noiseGreaterThan": "Gürültü daha büyük",
  "alerts.noiseGreaterThanThreshold": "{value}{unit} eşiğinden daha büyük gürültü",
  "alerts.noiseLessThan": "Gürültü daha az",
  "alerts.noiseLessThanThreshold": "{value}{unit} eşiğinden daha az gürültü",
  "alerts.noteOnConditions": "Aşağıdaki koşulların tümü doğrulandığında uyarının tetiklendiğini unutmayın",
  "alerts.pm10GreaterThan": "PM 10 daha büyük",
  "alerts.pm10GreaterThanThreshold": "PM 10 {value}{unit} eşiğinden daha büyük",
  "alerts.pm10LessThan": "PM 10'dan daha az",
  "alerts.pm10LessThanThreshold": "PM 10 {value}{unit} eşiğinden daha az",
  "alerts.pm1GreaterThan": "PM 1 daha büyük",
  "alerts.pm1GreaterThanThreshold": "PM 1 {value}{unit} eşiğinden daha büyük",
  "alerts.pm1LessThan": "PM 1'den daha az",
  "alerts.pm1LessThanThreshold": "PM 1 {value}{unit} eşiğinden daha az",
  "alerts.pm2p5GreaterThan": "PM 2.5 daha büyük",
  "alerts.pm2p5GreaterThanThreshold": "PM 2.5 {value}{unit} eşiğinden daha büyük",
  "alerts.pm2p5LessThan": "PM 2.5 daha az",
  "alerts.pm2p5LessThanThreshold": "PM 2.5 {value}{unit} eşiğinden daha az",
  "alerts.postStormSummary": "Yağış sonrası özeti",
  "alerts.postStormSynopsisHelper": "Her yağış sona erdiğinde özet bildirimi alırsınız.",
  "alerts.postStormSynopsisSoleCondition": "Fırtına sonrası özeti diğer koşullarla birleştirilemez.",
  "alerts.precipitationGreaterThan": "Saatlik yağış şundan fazla",
  "alerts.precipitationGreaterThanThreshold": "Saatlik yağış {value}{unit} eşiğini aştı",
  "alerts.pressureGreaterThan": "Basınç daha büyük",
  "alerts.pressureGreaterThanThreshold": "{value}{unit} eşiğinden daha büyük basınç",
  "alerts.pressureLessThan": "Basınç daha az",
  "alerts.pressureLessThanThreshold": "{value}{unit} eşiğinden daha az basınç",
  "alerts.rainRateGreaterThan": "Yağış yoğunluğu şundan fazla",
  "alerts.rainRateGreaterThanThreshold": "Yağış yoğunluğu {value}{unit} eşiğini aştı",
  "alerts.solarRadiationGreaterThan": "Güneş radyasyonu daha büyük",
  "alerts.solarRadiationGreaterThanThreshold": "{value}{unit} eşiğinden daha büyük güneş radyasyonu",
  "alerts.solarRadiationLessThan": "Güneş radyasyonu daha az",
  "alerts.solarRadiationLessThanThreshold": "{value}{unit} eşiğinden daha az güneş radyasyonu",
  "alerts.temperatureGreaterThan": "Sıcaklık daha büyük",
  "alerts.temperatureGreaterThanThreshold": "{value}{unit} eşiğinden büyük sıcaklık",
  "alerts.temperatureLessThan": "Sıcaklık daha az",
  "alerts.temperatureLessThanThreshold": "{value}{unit} eşiğinden daha az sıcaklık",
  "alerts.thswGreaterThan": "THSW daha büyük",
  "alerts.thswGreaterThanThreshold": "{value}{unit} eşiğinden büyük THSW",
  "alerts.thswLessThan": "THSW daha az",
  "alerts.thswLessThanThreshold": "{value}{unit} eşiğinden daha az THSW",
  "alerts.thwGreaterThan": "THW daha büyük",
  "alerts.thwGreaterThanThreshold": "{value}{unit} eşiğinden büyük THW",
  "alerts.thwLessThan": "THW daha az",
  "alerts.thwLessThanThreshold": "{value}{unit} eşiğinden daha az THW",
  "alerts.uvGreaterThan": "UV endeksi daha büyük",
  "alerts.uvGreaterThanThreshold": "{value}{unit} eşiğinden daha büyük UV dizin",
  "alerts.uvLessThan": "UV endeksi daha az",
  "alerts.uvLessThanThreshold": "{value}{unit} eşiğinden daha az UV endeksi",
  "alerts.visibilityGreaterThanThreshold": "{value}{unit} eşiğinden daha büyük görünürlük",
  "alerts.visibilityLessThanThreshold": "{value}{unit} eşiğinden daha az görünürlük",
  "alerts.visiblityGreaterThan": "Görünürlük daha büyük",
  "alerts.visiblityLessThan": "Görünürlük",
  "alerts.whichMeasure": "Hangi önlem için uyarılmak istersiniz?",
  "alerts.whichModule": "Hangi modül için uyarılmak istersiniz?",
  "alerts.windChillGreaterThan": "Rüzgar Soğutma daha büyük",
  "alerts.windChillGreaterThanThreshold": "{value}{unit} eşiğinden büyük Rüzgar Soğutma",
  "alerts.windChillLessThan": "Rüzgar Soğutma daha az",
  "alerts.windChillLessThanThreshold": "{value}{unit} eşiğinden daha az Rüzgar Soğutma",
  "alerts.windSpeedGreaterThan": "Rüzgar hızı daha büyük",
  "alerts.windSpeedGreaterThanThreshold": "Rüzgar hızı {value}{unit} eşiğinden daha büyük",
  "alerts.windSpeedLessThan": "Rüzgar hızı daha az",
  "alerts.windSpeedLessThanThreshold": "Rüzgar hızı {value}{unit} eşiğinden daha az",
  "astral.astronomicalSunPhase": "Astronomik {sunPhase}",
  "astral.civilSunPhase": "Sivil {sunPhase}",
  "astral.dawn": "Şafak",
  "astral.dusk": "Alacakaranlıkta",
  "astral.firstQuarter": "İlk çeyrek",
  "astral.fullMoon": "Dolunay",
  "astral.lastQuarter": "Son çeyrek",
  "astral.moon": "Ay",
  "astral.moonPhases": "Ay aşamaları",
  "astral.moonrise": "Ay doğumu",
  "astral.moonset": "Ayın batışı",
  "astral.nauticalSunPhase": "Denizcilik {sunPhase}",
  "astral.newMoon": "Yeni ay",
  "astral.noon": "Öğlen",
  "astral.remainingDaylight": "Kalan gün ışığı",
  "astral.sunrise": "Gündoğumu",
  "astral.sunriseAndSunset": "Gün doğumu ve gün batımı",
  "astral.sunriseAt": "Gün doğumu {time}",
  "astral.sunset": "Gün batımı",
  "astral.sunsetAt": "Gün batımı {time}",
  "astral.totalDaylight": "Toplam gün ışığı",
  "astral.waningCrescent": "Küçülen hilal",
  "astral.waningGibbous": "Küçülen şişkin ay",
  "astral.waxingCrescent": "Büyüyen hilal",
  "astral.waxingGibbous": "Büyüyen şişkin ay",
  "auth.alreadyHaveAccount": "Zaten bir hesabınız var mı?",
  "auth.authContainerTagline": "Kişisel hava durumu panonuz. İstasyonlarınızı bağlayın ve gerçek zamanlı verilere parmaklarınızın ucunda ulaşın.",
  "auth.backToLogin": "Giriş sayfasına dön",
  "auth.catchPhrase": "Hava Durumu İstihbarat Platformu",
  "auth.checkYourEmail": "E-postanızı kontrol edin",
  "auth.continueWithApple": "Apple ile devam et",
  "auth.continueWithFacebook": "Facebook ile devam et",
  "auth.continueWithGoogle": "Google ile devam et",
  "auth.email": "E -posta adresi",
  "auth.emailRequiredLoginFacebook": "E -posta izni gereklidir.",
  "auth.emailVerification": "E -posta Doğrulama",
  "auth.emailVerificationFailure": "E -posta doğrulamanızda bir sorun meydana geldi.",
  "auth.emailVerificationSuccess": "E -postanız başarıyla doğrulandı.",
  "auth.firstName": "İlk adı",
  "auth.forgotPassword": "Şifrenizi mi unuttunuz?",
  "auth.forgotPasswordSubtitle": "E-postanızı girin, size şifrenizi sıfırlamak için bir bağlantı göndereceğiz.",
  "auth.lastName": "Soy isim",
  "auth.login": "Giriş yap",
  "auth.loginSubtitle": "Tekrar hoş geldiniz! Lütfen bilgilerinizi girin.",
  "auth.loginToSmartMixinDescription": "Hesabınıza erişmek için SmartMixin kimlik bilgilerinizi girin.",
  "auth.logout": "Oturumu kapat",
  "auth.logoutConfirmation": "Oturumu kapatmak istediğinden emin misiniz?",
  "auth.noAccountYet": "Henüz bir hesabınız yok mu?",
  "auth.or": "veya",
  "auth.password": "Şifre",
  "auth.passwordAgain": "Tekrar şifre",
  "auth.passwordReset": "Parola Sıfırlama",
  "auth.passwordResetSuccess": "Şifreniz başarıyla güncellendi.",
  "auth.register": "Hesap oluştur",
  "auth.registerDescription": "Hava istasyonlarınızı bağlamak, hava durumu verilerini takip etmek ve güçlü analiz araçlarına erişmek için ücretsiz bir SmartMixin hesabı oluşturun.",
  "auth.registerSubtitle": "Başlamak için hesabınızı oluşturun.",
  "auth.registerSuccess": "Başarılı bir şekilde kayıt yaptırdınız! Size daha fazla talimat içeren {emailAddress} 'te bir doğrulama bağlantısı gönderdik.",
  "auth.restorePassword": "Şifre Geri Yükle",
  "auth.restorePasswordSuccess": "Size daha fazla talimat içeren {emailAddress} adresinden bir şifre sıfırlama bağlantısı gönderdik.",
  "auth.sendReset": "Sıfırlama talimatlarını gönderin",
  "auth.socialAccount": "veya hesabınızı kullanın",
  "auth.welcome": "Smartmixine hoş geldiniz",
  "auth.welcomeBack": "Tekrar hoşgeldiniz!",
  "calendar.april": "Nisan",
  "calendar.august": "Ağustos",
  "calendar.dateFormat": "Tarih biçimi",
  "calendar.day": "Gün",
  "calendar.december": "Aralık",
  "calendar.end": "Son",
  "calendar.february": "Şubat",
  "calendar.hours": "Saat",
  "calendar.hoursShort": "saat",
  "calendar.january": "Ocak",
  "calendar.july": "Temmuz",
  "calendar.june": "Haziran",
  "calendar.last24Hours": "Son 24 Saat",
  "calendar.last30Days": "Son 30 Gün",
  "calendar.last7Days": "Son 7 Gün",
  "calendar.march": "Mart",
  "calendar.max": "Maksimum",
  "calendar.may": "Mayıs",
  "calendar.month": "Ay",
  "calendar.months": "aylar",
  "calendar.november": "Kasım",
  "calendar.october": "Ekim",
  "calendar.oneDay": "1 gün",
  "calendar.oneHour": "1 saat",
  "calendar.oneMonth": "1 aylık",
  "calendar.oneWeek": "1 haftalık",
  "calendar.previous24Hours": "Önceki 24 Saat",
  "calendar.previous30Days": "Önceki 30 gün",
  "calendar.previous7Days": "Önceki 7 gün",
  "calendar.previousDay": "Önceki Gün",
  "calendar.previousMonth": "Önceki Ay",
  "calendar.previousWeek": "Önceki Hafta",
  "calendar.previousYear": "Önceki yıl",
  "calendar.sameDayLastYear": "Geçen yıl aynı gün",
  "calendar.sameMonthLastYear": "Geçen yıl aynı ay",
  "calendar.selectADate": "Bir Tarih Seçin",
  "calendar.selectAggregation": "Görüntülenen değeri seçin",
  "calendar.selectAMonth": "Bir Ay Seçin",
  "calendar.selectAYear": "Bir Yıl Seçin",
  "calendar.selectGranularity": "Bir tanecik seçin",
  "calendar.selectTimescale": "Bir Zaman Ölçeği Seçin",
  "calendar.september": "Eylül",
  "calendar.sixHours": "6 saat",
  "calendar.start": "Başlangıç",
  "calendar.thirtyMinutes": "30 dakika",
  "calendar.threeHours": "3 saat",
  "calendar.use24HourFormat": "24 saatlik format kullanın",
  "calendar.week": "Hafta",
  "calendar.year": "Yıl",
  "calendar.yesterday": "Dün",
  "common.accountDeleted": "Hesabınız başarıyla silindi.",
  "common.accountOnHold": "Hesap bağlantınızın süresi doldu. Veri güncellemelerini sürdürmek için lütfen yeniden bağlanın.",
  "common.add": "Ekle",
  "common.addAStation": "Bir İstasyon Ekle",
  "common.addToFavorites": "Favorilere ekle",
  "common.addYourOwnStation": "Kendi istasyonunuzu ekleyin",
  "common.alreadyPremium": "Zaten premium bir hesabınız var!",
  "common.alsoAvailableOn": "Şurada da mevcut:",
  "common.altitude": "Yükseklik",
  "common.analysis": "Analiz",
  "common.aroundMe": "Etrafımda",
  "common.articleCount": "{count} makale",
  "common.articleNotFound": "Makale Bulunamadı",
  "common.articleNotFoundDescription": "Aradığınız makale mevcut değil.",
  "common.average": "Ortalama",
  "common.averageOverThePeriod": "Dönem boyunca ortalama",
  "common.away": "Uzak",
  "common.back": "Geri",
  "common.backToHelpCenter": "Yardım Merkezine Dön",
  "common.backToHome": "Ana Sayfaya Dön",
  "common.bad": "Kötü",
  "common.batteryLevel": "Akü seviyesi",
  "common.bestValue": "En İyi Değer",
  "common.billingDetailsAndroid": "Ücretsiz deneme teklifi için, ücretsiz tanıtım süresinin süresi dolmadan 24 saat önce iptal ederseniz ücret alınmayacaktır. Deneme bittiğinde, SmartMixin aboneliğini Google Play hesap ayarlarınız aracılığıyla istediğiniz zaman iptal edebilirsiniz veya otomatik olarak yenilenir. Bu, yukarıdaki düğmede gösterilen başka bir ücretin tahsil edilmesinden kaçınmak için abonelik süresinin bitiminden 24 saat önce yapılmalıdır. Abonelik ödemeleri, satın alma işleminizin onaylanması ve her bir yenileme döneminin başlangıcında Google Play hesabınıza tahsil edilecektir.",
  "common.billingDetailsIos": "Ücretsiz deneme teklifi için, ücretsiz tanıtım süresinin süresi dolmadan 24 saat önce iptal ederseniz ücret alınmayacaktır. Deneme bittiğinde, SmartMixin aboneliğini App Store hesap ayarlarınız aracılığıyla istediğiniz zaman iptal edebilirsiniz veya otomatik olarak yenilenir. Bu, yukarıdaki düğmede gösterilen başka bir ücretin tahsil edilmesinden kaçınmak için abonelik süresinin bitiminden 24 saat önce yapılmalıdır. Abonelik ödemeleri, satın alma işleminizin onaylanması ve her bir yenileme döneminin başlangıcında App Store hesabınıza tahsil edilecektir.",
  "common.boilerOn": "Kazan",
  "common.browseByCategory": "Kategoriye göre göz at",
  "common.calendarView": "Takvim görünümü",
  "common.cancel": "İptal",
  "common.cannotBeEmpty": "Bu alan boş olamaz.",
  "common.cardDetails": "Kart Ayrıntıları",
  "common.categoryNotFound": "Kategori bulunamadı",
  "common.categoryNotFoundDescription": "Bu kategori mevcut değil veya makale içermiyor.",
  "common.charts": "Grafikler",
  "common.chartView": "Grafik Görünümü",
  "common.clearRecentLocations": "Tümünü temizle",
  "common.close": "Kapat",
  "common.comparison": "Karşılaştırma",
  "common.contactMe": "Benimle iletişime geçin",
  "common.currentDay": "Geçerli gün",
  "common.currentLocation": "Mevcut Konum",
  "common.currentObservations": "Mevcut gözlemler",
  "common.currentRainEvent": "Mevcut Yağmur Etkinliği",
  "common.currentRate": "Mevcut Oran",
  "common.currentWeatherConditions": "Mevcut Koşullar",
  "common.customizeComparisonMetrics": "Ölçümleri özelleştir",
  "common.customizeComparisonMetricsDescription": "Karşılaştırma ölçümlerinizi yeniden sıralamak için öğeleri sürükleyin. Ölçümleri göstermek veya gizlemek için göz simgesine dokunun.",
  "common.customizeDashboard": "Özelleştir",
  "common.customizeDashboardDescription": "Panelinizdeki sıralamayı değiştirmek için öğeleri sürükleyin. Bölümleri göstermek veya gizlemek için göz simgesine dokunun.",
  "common.customizedStationName": "Özelleştirilmiş İstasyon Adı",
  "common.dailyForecast": "Günlük Tahmin",
  "common.dashboard": "Gösterge paneli",
  "common.default": "Varsayılan",
  "common.defaultForecastModelChip": "Varsayılan · {name}",
  "common.delete": "Sil",
  "common.deleteAccount": "Hesabınızı Sil",
  "common.deleteAccountConfirmation": "Hesabınızı silmek istediğinizden emin misiniz? Bu eylem geri döndürülemez.",
  "common.deleteAccountDescription": "Bu eylem hesabınızı ve tüm bilgilerinizi siler. Geri dönüş yok.",
  "common.details": "Detaylar",
  "common.edit": "Düzenle",
  "common.editor": "Editör",
  "common.endTime": "Son zaman",
  "common.exitFullscreen": "Tam ekrandan çık",
  "common.exploreWeatherMap": "Hava Haritasını Keşfet",
  "common.favoriteLocations": "Favoriler",
  "common.favoriteLocationsEmpty": "En fazla 5 favori yer ekleyebilirsiniz.",
  "common.favoriteStations": "Favori İstasyonlar",
  "common.feedbackHelpsImprove": "Görüşleriniz yardım makalelerimizi geliştirmemize yardımcı oluyor.",
  "common.feedbackReasonNotAnswer": "Sorumu yanıtlamıyor",
  "common.feedbackReasonOutdated": "Bilgiler güncel değil",
  "common.feedbackReasonUnclear": "Talimatlar net değil",
  "common.feedbackWhatWentWrong": "Sorun neydi?",
  "common.filterStationDescription": "Güvenilmez önlemlerle istasyonları görüntülemeyin",
  "common.filterStations": "Filtre istasyonları",
  "common.filterStationSourceDescription": "Haritada görüntülemek istediğiniz istasyon sağlayıcılarını seçin",
  "common.findStationsNearYou": "Yakınınızdaki istasyonları bulun",
  "common.firmwareVersion": "Ürün yazılımı sürümü",
  "common.forecast": "Tahmin",
  "common.forecastComparisonDescription": "Birkaç kaynaktan tahmin model çıkışlarını kolayca karşılaştırın",
  "common.forecastModelComparison": "Tahmin modeli karşılaştırması",
  "common.forecastModelCoverage": "Kapsama",
  "common.forecastModelDescription": "Açıklama",
  "common.forecastModelDescription_AROME": "Météo France'ın Batı Avrupa üzerinde 1,3 km çözünürlükte konveksiyonu çözen yüksek çözünürlüklü modeli. Fransa'daki kısa vadeli tahminler için sınıfının en iyisi; üç saatte bir güncellenir.",
  "common.forecastModelDescription_ARPEGE_EU": "Météo France'ın ARPEGE modelinin 10 km çözünürlükteki Avrupa yuvası. Avrupa üzerinde orta vadeli tahminler, günde dört kez güncellenir.",
  "common.forecastModelDescription_ARPEGE_GLOBAL": "Météo France'ın 25 km çözünürlükte yaklaşık 4 güne kadar çalışan küresel sayısal hava tahmin modeli. Günde dört kez güncellenir.",
  "common.forecastModelDescription_EC_GDPS": "Environment Canada'nın Küresel Deterministik Tahmin Sistemi: 15 km çözünürlükte 10 güne kadar çalışan dünya çapında orta vadeli model, günde iki kez güncellenir.",
  "common.forecastModelDescription_EC_RDPS": "Environment Canada'nın Bölgesel Deterministik Tahmin Sistemi: Kuzey Amerika üzerinde 10 km çözünürlükte orta vadeli model, günde dört kez güncellenir.",
  "common.forecastModelDescription_GFS": "NOAA'nın amiral gemisi orta vadeli küresel modeli. Tüm gezegeni 25 km çözünürlükte 16 güne kadar kapsar, günde dört kez güncellenir.",
  "common.forecastModelDescription_HRRR_CONUS": "NOAA'nın High-Resolution Rapid Refresh modeli: kıta ABD üzerinde 3 km çözünürlükte konveksiyonu çözen model, her saat güncellenir. Fırtınalar ve şiddetli hava koşullarının çok kısa vadeli tahminleri için en uygundur.",
  "common.forecastModelDescription_ICON_DE": "DWD'nin Almanya ve çevre ülkeler üzerinde 2,2 km çözünürlükte konveksiyonu çözen yüksek çözünürlüklü modeli. Kısa vadeli tahminler günde iki kez güncellenir.",
  "common.forecastModelDescription_ICON_EU": "DWD'nin ICON modelinin Avrupa ve Kuzey Atlantik'i kapsayan 7 km çözünürlükteki Avrupa yuvası. Orta vadeli tahminler günde dört kez güncellenir.",
  "common.forecastModelDescription_MET_NORWAY": "Norveç Meteoroloji Enstitüsü'nün açık hava tahmini hizmeti, yüksek çözünürlüklü İskandinav modellerini ECMWF verileriyle birleştirerek 10 güne kadar dünya çapında tahminler sunar.",
  "common.forecastModelDescription_MF_AROME_ANTILLES": "Fransız Antilleri (Guadeloupe, Martinique) üzerinde 2,5 km çözünürlükte AROME yuvası. Kısa vadeli tahminler günde dört kez güncellenir.",
  "common.forecastModelDescription_MF_AROME_GUYANE": "Fransız Guyanası üzerinde 2,5 km çözünürlükte AROME yuvası. Kısa vadeli tahminler günde dört kez güncellenir.",
  "common.forecastModelDescription_MF_AROME_NOUVELLE_CALEDONIE": "Yeni Kaledonya üzerinde 2,5 km çözünürlükte AROME yuvası. Kısa vadeli tahminler günde dört kez güncellenir.",
  "common.forecastModelDescription_MF_AROME_POLYNESIE": "Fransız Polinezyası üzerinde 2,5 km çözünürlükte AROME yuvası. Kısa vadeli tahminler günde dört kez güncellenir.",
  "common.forecastModelDescription_MF_AROME_REUNION_MAYOTTE": "Réunion ve Mayotte üzerinde 2,5 km çözünürlükte AROME yuvası. Kısa vadeli tahminler günde dört kez güncellenir.",
  "common.forecastModelDescription_NAM_CONUS": "NOAA'nın North American Mesoscale model yuvası, kıta ABD üzerinde 5 km çözünürlükte. Kısa vadeli tahminler günde dört kez güncellenir.",
  "common.forecastModelDescription_NAM_NORTH_AMERICA": "Tüm Kuzey Amerika'yı 32 km çözünürlükle kapsayan NOAA'nın North American Mesoscale modeli. Günde dört kez güncellenir.",
  "common.forecastModelDescription_SMARTMIXIN_MULTIMODEL": "SmartMixin'in amiral gemisi tahmini. Konumunuzdaki her saat için mevcut en iyi modeli seçiyoruz — genellikle bir tane varsa yüksek çözünürlüklü bir bölgesel model (Fransa'da AROME, Almanya'da ICON-D2, ABD'de HRRR, kıtanın her yerinde ARPEGE Europe…) ve başka yerlerde küresel bir modele geri dönüyoruz — sonra komşu kaynaklardan boşlukları dolduruyoruz. Sonuç, dünyanın herhangi bir yerini 14 güne kadar kapsayan tek bir kesintisiz tahmindir ve altta yatan modellerden herhangi biri güncellendiğinde otomatik olarak yenilenir.",
  "common.forecastModelDescription_WEATHERFLOW_FORECAST": "Birden fazla sayısal hava tahmin modelini, Tempest hava istasyonu ağından gelen gözlemlerle birleştiren Weatherflow'un tescilli küresel tahmini. 10 günlük dünya çapında ufuk.",
  "common.forecastModelDetailTitle": "Tahmin modeli",
  "common.forecastModelScopeGlobal": "Küresel",
  "common.forecastModelScopeGlobalDescription": "Bu model tüm gezegeni kapsar.",
  "common.forecastModelScopeRegional": "Bölgesel",
  "common.forecastModelScopeRegionalDescription": "Bu model yalnızca belirli bir bölgeyi kapsar.",
  "common.forecastModelSpecifications": "Özellikler",
  "common.forecastSources": "Tahmin Kaynakları",
  "common.freeAccount": "Ücretsiz hesap",
  "common.freeSubscription": "Ücretsiz premium abonelik",
  "common.freeTrialForPeriod": "{period} günleri için ücretsiz deneme",
  "common.frequency": "Sıklık",
  "common.full": "Tam dolu",
  "common.fullscreen": "Tam ekran",
  "common.getStartedFree": "Ücretsiz Başla",
  "common.getUnlimitedAccess": "Sınırsız erişim:",
  "common.good": "İyi",
  "common.hail": "Dolu",
  "common.help": "Yardım",
  "common.helpCategoryAccount": "Hesap",
  "common.helpCategoryBilling": "Faturalandırma",
  "common.helpCategoryGettingStarted": "Başlarken",
  "common.helpCategoryProviders": "Sağlayıcılar",
  "common.helpCategoryStations": "İstasyonlar",
  "common.helpCategoryTroubleshooting": "Sorun Giderme",
  "common.helpCenter": "Yardım Merkezi",
  "common.helpCenterDescription": "Sık sorulan sorulara yanıtlar bulun ve SmartMixin'den en iyi şekilde nasıl yararlanacağınızı öğrenin.",
  "common.hg": "Donma koruyucusu",
  "common.hidden": "Gizli",
  "common.hiddenSensors": "Gizli sensörler",
  "common.hiddenStations": "Gizli İstasyonlar",
  "common.hiddenStationsDescription": "Yanındaki göz simgesine dokunarak bir istasyonu tekrar gösterebilirsiniz.",
  "common.high": "Yüksek",
  "common.home": "Ev",
  "common.homeConnectService": "Hava durumu istasyonunuz var mı? Servisinizi bağlayın",
  "common.homeInformation": "Ev bilgileri",
  "common.homeIntroduction": "SmartMixin özelliklerinin tadını çıkarmak için harici hesaplarınızı bağlamaya başlayın.",
  "common.homeName": "Ev adı",
  "common.homeSubtitle": "Hava durumunuz, hepsi tek bir yerde",
  "common.horizon": "Ufuk",
  "common.horizonValue": "{value} saatlerine kadar",
  "common.iDontKnowYet": "Henüz bilmiyorum",
  "common.indoor": "Kapalı",
  "common.lastRainEvent": "Son Yağmur Etkinliği",
  "common.lastUpdate": "Son Güncelleme",
  "common.legendHeavy": "Yoğun",
  "common.legendLight": "Hafif",
  "common.legendLightningHelp": "Renk, son {minutes} dakikadaki her yıldırımın yaşını gösterir — en yeniler beyaz, en eskiler koyu kırmızı.",
  "common.legendNewest": "En yeni",
  "common.legendOldest": "En eski",
  "common.legendStationsHelp": "İşaretçi rengi seçili ölçümün değerini yansıtır.",
  "common.lightningDataAttribution": "Yıldırım verileri: Blitzortung.org",
  "common.lightningStrikes": "Yıldırım düşmeleri",
  "common.lightningStrikesDescription": "Yıldırım düşmelerini haritada gerçek zamanlı göster",
  "common.linkToSection": "Bu bölüme bağlantı",
  "common.loading": "Yükleme",
  "common.location": "Konum",
  "common.locationAddedToFavorites": "Favorilere yer eklendi",
  "common.locationNotGranted": "Konum izni verilmez. Lütfen cihaz ayarlarındaki konumunuza erişim sağlayın.",
  "common.locationRemovedFromFavorites": "Konum favorilerden kaldırıldı",
  "common.locations": "Yerler",
  "common.low": "Düşük",
  "common.manage": "Yönet",
  "common.manageAccount": "Hesabı Yönetin",
  "common.manageMySubscription": "Aboneliğimi yönetin",
  "common.manageSensors": "Sensörleri yönet",
  "common.manageSensorsDescription": "Sensörleri yeniden sıralamak için öğeleri sürükleyin. Sensörleri göstermek veya gizlemek için göz simgesine dokunun. Yeniden adlandırmak için bir isme dokunun.",
  "common.manualBoost": "Manuel destek",
  "common.manualSetpointUntil": "Manuel ayar noktası",
  "common.mapLayers": "Harita katmanları",
  "common.mapLegend": "Harita göstergesi",
  "common.maxFavoriteLocationsReached": "Sadece en fazla 5 favori yere sahip olabilirsiniz. Birini eklemek için bir tane çıkarın.",
  "common.maximum": "Maksimum",
  "common.measureToDisplay": "Görüntülemek için ölçüm",
  "common.medium": "Orta",
  "common.meshSize": "Izgara boyutu",
  "common.minimum": "Minimum",
  "common.minRead": "{minutes} dk okuma",
  "common.modifyFavoriteStations": "Favori istasyonları değiştirin",
  "common.modifyFavoriteStationsDescription": "En sevdiğiniz istasyonları sürükleyerek yeniden sıralayabilirsiniz. Bunları listeden de kaldırabilirsiniz.",
  "common.moduleType": "Modül Türü",
  "common.monthTotal": "Ay toplam",
  "common.more": "Daha",
  "common.moreInformation": "Daha Fazla Bilgi",
  "common.myLocation": "Konumum",
  "common.nearbyWeatherStations": "Yakın hava istasyonları",
  "common.next": "Sonraki",
  "common.nextHours": "Sonraki Saatler",
  "common.no": "Hayır",
  "common.noAccountNeeded": "Hesap gerekmez",
  "common.noDataForThisPeriod": "Bu dönem için veri yok",
  "common.noLocationsFound": "Konum bulunamadı",
  "common.noNetatmoWeatherStationYet": "Henüz bir netatmo hava istasyonunuz yok.",
  "common.noOutdoorModule": "Bu istasyon için işlevsel bir dış mekan modülü yoktur.",
  "common.noSearchResults": "Aramanızla eşleşen makale yok",
  "common.noStationsFound": "İstasyon bulunamadı",
  "common.noThermostatYet": "Henüz termostatınız yok.",
  "common.notNow": "Şimdi Değil",
  "common.notPurchasedYet": "Görünüşe göre bu henüz satın alınmadı.",
  "common.noWeatherStation": "Hava istasyonu yok",
  "common.noWeatherStationYet": "Henüz bir hava istasyonunuz yok.",
  "common.numberOfActiveWarnings": "{warning_count} aktif Hava Durumu",
  "common.onThisPage": "Bu sayfada",
  "common.openSettings": "Ayarlar Aç",
  "common.orChooseMonthly": "Veya aylık seçin:",
  "common.outdatedModule": "Bu modülün verileri güncel değildir.",
  "common.outdoor": "Dış mekan",
  "common.outdoorTemperature": "Dış mekan sıcaklığı",
  "common.pageNotFound": "Sayfa Bulunamadı",
  "common.pageNotFoundDescription": "Aradığınız sayfa mevcut değil veya taşınmış.",
  "common.passwordUpdated": "Parola başarıyla güncellendi.",
  "common.personalWeatherIntelligence": "Kişisel Hava Durumu Zekanız",
  "common.platformMobileApp": "Mobil uygulama",
  "common.platformMobileOnly": "Yalnızca mobil uygulamada",
  "common.platformWebApp": "Web uygulaması",
  "common.platformWebOnly": "Yalnızca web uygulamasında",
  "common.popularArticles": "Popüler makaleler",
  "common.premiumAccount": "Premium hesabı",
  "common.premiumDescription": "Premium abonelik, gelişmiş hava durumu analizi, grafik karşılaştırmaları, bölgesel tahmin modelleri ve çok daha fazlası gibi birçok ek özelliğin kilidini açar.",
  "common.premiumFeatureAlerts": "Hava Uyarıları",
  "common.premiumFeatureAnalysis": "Gelişmiş Hava Analizi",
  "common.premiumFeatureCharts": "Grafik Karşılaştırmaları",
  "common.premiumFeatureExport": "Veri Dışa Aktarma",
  "common.premiumFeatureForecast": "Bölgesel Tahmin Modelleri",
  "common.premiumFeatureNotification": "Durum Çubuğu Widget'ı",
  "common.premiumFeatureTitle": "Premium Özellik",
  "common.premiumFeatureWidgets": "Ana ekran widget'ları",
  "common.pressureSummary": "Basınç özeti",
  "common.previous": "Öncesi",
  "common.previousHours": "Önceki saatler",
  "common.profileUpdated": "Profil başarıyla güncellendi.",
  "common.purchasedNetatmoPro": "Daha önce NetatMo Pro ({date}) satın almışsınızdır. Premium özelliklerin bir alt kümesine erişmenizi sağlar. Tüm premium özelliklere erişmek istiyorsanız aşağıdaki tekliflerden birine abone olun.",
  "common.radarDataAttribution": "Radar verileri: RainViewer.com",
  "common.rain": "Yağmur",
  "common.rainEvents": "Yağmur Etkinlikleri",
  "common.rainfallMeasurement": "Yağış ölçümü",
  "common.rainRadar": "Yağmur radarı",
  "common.rainRadarDescription": "Haritada yağmur radar kaplamasını göster",
  "common.rainSummary": "Yağmur Özeti",
  "common.range": "Menzil",
  "common.recentLocations": "Son",
  "common.recentLocationsEmpty": "Yakın tarihin boş.",
  "common.recentStations": "Son İstasyonlar",
  "common.relatedArticles": "İlgili Makaleler",
  "common.relay": "Röle",
  "common.removeFromFavorites": "Favorilerden kaldır",
  "common.renameSensors": "Sensörleri Yeniden Adlandır",
  "common.resetZoom": "Zoom'u sıfırla",
  "common.restorePurchase": "Satın Alma Geri Yükle",
  "common.room": "Oda",
  "common.rooms": "Odalar",
  "common.savingsPercent": "%{percent} Tasarruf",
  "common.searchArticles": "Makale ara...",
  "common.searchForALocation": "Konum ara...",
  "common.searchForLocation": "Bir konum arayın",
  "common.searchForWeatherStation": "Hava istasyonu arayın",
  "common.searchResults": "Arama Sonuçları",
  "common.searchResultsEmpty": "Sonuç bulunamadı.",
  "common.searchResultsFound": "{count, plural, one {# sonuç bulundu} other {# sonuç bulundu}}",
  "common.searchStationsDescription": "Yakındaki hava istasyonlarını bulmak için bir şehir, adres veya yer adı girin.",
  "common.searchStationsHint": "Dünyanın herhangi bir yerindeki hava istasyonlarını keşfetmek için yukarıdaki arama çubuğunu kullanın.",
  "common.selectStationForComparison": "Karşılaştırmak için bir istasyon seçin",
  "common.selectWeatherForecastProvider": "Lütfen bir hava sağlayıcısı seçin",
  "common.serialNumber": "Seri numarası",
  "common.share": "Paylaş",
  "common.shareOutdoorMeasures": "Açık hava önlemlerinizi paylaşın",
  "common.shareOutdoorMeasuresDescription": "Açık hava önlemlerinizi başkaları tarafından görülebilir hale getirerek Smartmixin topluluğuna katılın. İç mekan önlemleri asla paylaşılmayacak.",
  "common.shareYourWeather": "Havanızı Paylaşın",
  "common.signalStrength": "Sinyal gücü",
  "common.skip": "Atla",
  "common.smartThermostat": "Akıllı termostat",
  "common.smartValve": "Akıllı valf",
  "common.snow": "Kar",
  "common.start": "Başlangıç",
  "common.startFreeTrial": "Ücretsiz Denemeyi Başlat",
  "common.startTime": "Başlangıç Zamanı",
  "common.station": "istasyon",
  "common.stationAddedToFavorites": "Sık kullanılanlara istasyon eklendi",
  "common.stationComparison": "İstasyon karşılaştırması",
  "common.stationComparisonDescription": "Tarihsel hava durumu verilerini başka bir istasyonla karşılaştırın",
  "common.stationInformation": "İstasyon bilgileri",
  "common.stationName": "İstasyon adı",
  "common.stationObservationsDescription": "Hava istasyonlarından en son gözlemleri görüntüleyin",
  "common.stationRemovedFromFavorites": "İstasyon favorilerinden kaldırıldı",
  "common.stations": "istasyonlar",
  "common.stationsNear": "Yakındaki istasyonlar",
  "common.stationType": "İstasyon tipi",
  "common.statusOffline": "Çevrimdışı",
  "common.statusOnline": "Çevrimiçi",
  "common.statusStale": "Eski",
  "common.statusSyncing": "Senkronize ediliyor",
  "common.stillNeedHelp": "Hâlâ yardıma mı ihtiyacınız var?",
  "common.stillNeedHelpDescription": "Bu makale sorunuzu yanıtlamadıysa size doğrudan yardımcı olmaktan memnuniyet duyarım.",
  "common.subscribeNow": "Şimdi abone ol - deneme süresi yok",
  "common.sumOverThePeriod": "Dönem boyunca toplam",
  "common.switchToPremium": "Smartmixin Premium'a geç",
  "common.temperatureShort": "Sıcaklık",
  "common.temperatureSummary": "Sıcaklık Özeti",
  "common.thankYouForFeedback": "Geri bildiriminiz için teşekkürler!",
  "common.thenPrice": "sonra {price}",
  "common.timeSelection": "Zaman seçimi",
  "common.timezone": "Zaman dilimi",
  "common.totalDuration": "Toplam Süre",
  "common.tryAnotherLocation": "Bu konumun yakınında hava istasyonu bulamadık. Farklı bir bölgede aramayı deneyin.",
  "common.unknown": "Bilinmeyen",
  "common.untilChanged": "Değişene kadar",
  "common.untilTime": "{time}",
  "common.upgrade": "Güncelleme",
  "common.upgradeRequiredAndroid": "Başvurunuzun yükseltilmesi gereklidir. Yükseltmek için Google Play'i ziyaret edin.",
  "common.upgradeRequiredIos": "Başvurunuzun yükseltilmesi gereklidir. Yükseltmek için App Store'u ziyaret edin.",
  "common.validate": "Doğrula",
  "common.validEmail": "Geçerli bir e -posta adresi gereklidir.",
  "common.very_low": "Çok düşük",
  "common.visitNetatmoWebsite": "Netatmo web sitesini ziyaret edin",
  "common.wasArticleHelpful": "Bu makale yardımcı oldu mu?",
  "common.weatherCondition": "Hava durumu",
  "common.weatherflowNCRain": "NC Rain (Yakın Yağmur)",
  "common.weatherflowNCRainDescription": "NC Rain, Nearcast teknolojisi tarafından desteklenen Tempest Hava Durumu Sistemi aracılığıyla sağlanan ek bir veri kaynağıdır. NC Yağmur Verileri",
  "common.weatherForecastModels": "Hava Tahmin Modelleri",
  "common.weatherIntelligencePlatform": "Hava Durumu Zekası Platformu",
  "common.weatherMap": "Hava haritası",
  "common.weatherMapMetaDescription": "SmartMixin, dünya genelinde hava koşulları için etkileşimli hava durumu ve radar haritaları sunar.",
  "common.weatherObservations": "Hava Gözlemleri",
  "common.weatherStation": "Hava durumu istasyonu",
  "common.weatherStations": "Hava istasyonları",
  "common.welcome": "Smartmixine hoş geldiniz!",
  "common.whenBackHome": "Ne zaman eve döneceksin?",
  "common.wifiStrength": "WiFi Gücü",
  "common.wind": "Rüzgâr",
  "common.windMeasurement": "Rüzgar ölçümü",
  "common.windSpeed": "Rüzgar hızı",
  "common.windSummary": "Rüzgar özeti",
  "common.yearToDate": "Sene başından beri",
  "common.yes": "Evet",
  "common.zoomImage": "Görseli büyüt",
  "forecastMaps.addColor": "Renk ekle",
  "forecastMaps.addLayer": "Katman ekle",
  "forecastMaps.autoPreview": "Otomatik",
  "forecastMaps.backToMaps": "Haritalara dön",
  "forecastMaps.browseMaps": "Haritalara göz at",
  "forecastMaps.build": "Oluştur",
  "forecastMaps.buildCompleted": "Oluşturma tamamlandı",
  "forecastMaps.builderMetaDescription": "Hava durumu modellerinin katmanlarından özel tahmin haritaları oluşturun.",
  "forecastMaps.builderTitle": "Harita oluşturucu",
  "forecastMaps.buildFailed": "Oluşturma başarısız oldu. Lütfen tekrar deneyin.",
  "forecastMaps.buildNotPossible": "Bu harita henüz oluşturulamıyor — kullanılabilir tahmin verisi yok.",
  "forecastMaps.buildProgress": "İşleniyor… {completed}/{total} adım",
  "forecastMaps.buildStarting": "Oluşturma başlatılıyor…",
  "forecastMaps.byModel": "Modele göre",
  "forecastMaps.byZone": "Bölgeye göre",
  "forecastMaps.colormap": "Renk skalası",
  "forecastMaps.colormapCustom": "Özel renkler",
  "forecastMaps.colormapGroupDomain": "Hava durumu ön ayarları",
  "forecastMaps.colormapGroupMatplotlib": "Bilimsel ön ayarlar",
  "forecastMaps.comingSoon": "Bu görünüm çok yakında.",
  "forecastMaps.contourLevels": "Kontur seviyeleri",
  "forecastMaps.countryCanada": "Kanada",
  "forecastMaps.countryFrance": "Fransa",
  "forecastMaps.countryGermany": "Almanya",
  "forecastMaps.countryItaly": "İtalya",
  "forecastMaps.countryScandinavia": "İskandinavya",
  "forecastMaps.countrySpain": "İspanya",
  "forecastMaps.countrySwitzerland": "İsviçre",
  "forecastMaps.countryUnitedStates": "Amerika Birleşik Devletleri",
  "forecastMaps.customColormapMinColors": "Özel bir renk skalası en az iki renk gerektirir",
  "forecastMaps.customExtent": "Özel kapsam",
  "forecastMaps.deleteMap": "Haritayı sil",
  "forecastMaps.deleteMapBody": "“{name}” ve işlenmiş çıktıları kalıcı olarak silinecek.",
  "forecastMaps.deleteMapTitle": "Bu harita silinsin mi?",
  "forecastMaps.displayName": "Görünen ad",
  "forecastMaps.downloadMp4": "MP4 indir",
  "forecastMaps.downscaling": "Rüzgar oku seyreltme katsayısı",
  "forecastMaps.dpi": "DPI",
  "forecastMaps.drawArea": "Alan çiz",
  "forecastMaps.east": "Doğu",
  "forecastMaps.editMap": "Haritayı düzenle",
  "forecastMaps.exportBuilding": "Video hazırlanıyor…",
  "forecastMaps.exportError": "Video dışa aktarılamadı. Lütfen tekrar deneyin.",
  "forecastMaps.exportMp4": "MP4 olarak dışa aktar",
  "forecastMaps.exportNotReady": "Video henüz hazır değil. Lütfen daha sonra tekrar deneyin.",
  "forecastMaps.extentDrawHint": "Alanı çizmek için harita üzerinde sürükleyin",
  "forecastMaps.extentInvalid": "Batı doğudan, güney de kuzeyden küçük olmalıdır",
  "forecastMaps.extentPanZoomHint": "Alan çerçeveyi dolduruncaya kadar kaydırın ve yakınlaştırın",
  "forecastMaps.flipbookView": "Animasyon",
  "forecastMaps.forecastModel": "Tahmin modeli",
  "forecastMaps.forkAndEdit": "Kopyala ve düzenle",
  "forecastMaps.height": "Yükseklik (inç)",
  "forecastMaps.hourOffset": "+{hour} sa",
  "forecastMaps.invalidHexColor": "Geçersiz renk — #RRGGBB kullanın",
  "forecastMaps.layers": "Katmanlar",
  "forecastMaps.layerTypeBarbs": "Rüzgar okları",
  "forecastMaps.layerTypeContour": "Kontur çizgileri",
  "forecastMaps.layerTypeFilledContour": "Dolu konturlar",
  "forecastMaps.layerTypeMagnitude": "Büyüklük",
  "forecastMaps.layerTypeRaster": "Raster",
  "forecastMaps.layerTypeVectorField": "Vektör alanı",
  "forecastMaps.leave": "Ayrıl",
  "forecastMaps.levelsCount": "Adet",
  "forecastMaps.levelsInvalid": "Geçersiz kontur seviyeleri",
  "forecastMaps.levelsModeArange": "Sabit adım",
  "forecastMaps.levelsModeExplicit": "Açık değerler",
  "forecastMaps.levelsModeLinspace": "Eşit aralıklı (adet)",
  "forecastMaps.levelsStep": "Adım",
  "forecastMaps.levelsValues": "Değerler",
  "forecastMaps.levelsValuesHint": "Virgülle ayrılmış, artan",
  "forecastMaps.localTimeHint": "Yerel saatinizle gösterilir",
  "forecastMaps.map": "Harita",
  "forecastMaps.mapDescription": "Açıklama",
  "forecastMaps.mapName": "Harita adı",
  "forecastMaps.mapNameRequired": "Bir ad girin",
  "forecastMaps.mapSettings": "Harita ayarları",
  "forecastMaps.mapView": "Etkileşimli harita",
  "forecastMaps.maxLayersReached": "Bu harita en fazla {max} katman sınırına ulaştı.",
  "forecastMaps.maxValue": "Maksimum değer",
  "forecastMaps.memoryBudgetExceeded": "Çözünürlük işleme bütçesini aşıyor — DPI'ı veya yüksekliği azaltın",
  "forecastMaps.memoryBudgetUsage": "İşleme bütçesi: {percent}%",
  "forecastMaps.metaDescription": "Hava durumu modellerinin çalıştırmalarından üretilen animasyonlu tahmin haritaları.",
  "forecastMaps.metric": "Ölçüm",
  "forecastMaps.metricRequired": "Bir ölçüm seçin",
  "forecastMaps.metricUnavailable": "Bu model için kullanılamıyor",
  "forecastMaps.minBelowMax": "Minimum, maksimumdan küçük olmalıdır",
  "forecastMaps.minMaxRequired": "Bu katman türü için minimum ve maksimum değerler zorunludur",
  "forecastMaps.minValue": "Minimum değer",
  "forecastMaps.modelNoRun": "Henüz tamamlanmış bir çalıştırma yok",
  "forecastMaps.moveLayerDown": "Aşağı taşı",
  "forecastMaps.moveLayerUp": "Yukarı taşı",
  "forecastMaps.myMaps": "Haritalarım",
  "forecastMaps.nanClipToMin": "Minimuma kırp",
  "forecastMaps.nanMask": "Maskele",
  "forecastMaps.nanPolicy": "Eksik veriler",
  "forecastMaps.nanSkip": "Atla",
  "forecastMaps.newMap": "Yeni harita",
  "forecastMaps.noCompletedRun": "Bu harita henüz oluşturulmadı. Lütfen daha sonra tekrar kontrol edin.",
  "forecastMaps.noLayers": "Henüz katman yok. Başlamak için bir katman ekleyin.",
  "forecastMaps.noMapsAvailable": "Henüz kullanılabilir tahmin haritası yok.",
  "forecastMaps.north": "Kuzey",
  "forecastMaps.opacity": "Opaklık",
  "forecastMaps.overlayLegend": "Lejant",
  "forecastMaps.pause": "Duraklat",
  "forecastMaps.play": "Oynat",
  "forecastMaps.pointValueError": "Bu nokta için tahmin yüklenemedi.",
  "forecastMaps.pointValueLoading": "Tahmin yükleniyor…",
  "forecastMaps.pointValueUnavailable": "Bu saat için veri yok.",
  "forecastMaps.presets": "Ön ayarlar",
  "forecastMaps.preview": "Önizleme",
  "forecastMaps.previewEmptyHint": "Önizleme oluşturmak için en az bir geçerli katman yapılandırın.",
  "forecastMaps.previewFailed": "Önizleme başarısız oldu",
  "forecastMaps.previewHour": "Tahmin saati",
  "forecastMaps.previewRendering": "Önizleme işleniyor…",
  "forecastMaps.projection": "Projeksiyon",
  "forecastMaps.projectionLambertConformal": "Lambert konform",
  "forecastMaps.projectionMercator": "Mercator",
  "forecastMaps.projectionPlateCarree": "Plate carrée",
  "forecastMaps.projectionStereographic": "Stereografik",
  "forecastMaps.regionEurope": "Avrupa",
  "forecastMaps.regionNorthAmerica": "Kuzey Amerika",
  "forecastMaps.removeColor": "Rengi kaldır",
  "forecastMaps.removeLayer": "Katmanı kaldır",
  "forecastMaps.retry": "Tekrar dene",
  "forecastMaps.run": "Çalıştırma: {run}",
  "forecastMaps.save": "Kaydet",
  "forecastMaps.selectExtentOnMap": "Haritada alan seç",
  "forecastMaps.south": "Güney",
  "forecastMaps.title": "Tahmin haritaları",
  "forecastMaps.uMetric": "U bileşeni",
  "forecastMaps.unitConversion": "Birim dönüştürme",
  "forecastMaps.unitNone": "Yok",
  "forecastMaps.unsavedChangesBody": "Kaydedilmemiş değişiklikleriniz var. Ayrılıp bunlar atılsın mı?",
  "forecastMaps.unsavedChangesTitle": "Kaydedilmemiş değişiklikler",
  "forecastMaps.useCurrentView": "Geçerli görünümü kullan",
  "forecastMaps.useModelDomain": "Kapalı: modelin tüm alanı kullanılır",
  "forecastMaps.utcTime": "UTC: {time}",
  "forecastMaps.uvMetricsDiffer": "U ve V ölçümleri farklı olmalıdır",
  "forecastMaps.validTime": "Geçerlilik: {time}",
  "forecastMaps.valueBetween": "{min} ile {max} arasında olmalıdır",
  "forecastMaps.variable": "Değişken",
  "forecastMaps.viewMap": "Haritayı görüntüle",
  "forecastMaps.vMetric": "V bileşeni",
  "forecastMaps.west": "Batı",
  "forecastMaps.windAnimation": "Rüzgar animasyonu",
  "intro.locationDescription": "Bulunduğun konuma özel doğru tahminler almak için konum erişimini etkinleştir — artık genel tahminlere son.",
  "intro.locationTitle": "Sana özel tahminler",
  "intro.notificationDescription": "Yağmur, kar veya şiddetli hava koşulları gibi önemli değişiklikleri zamanında öğrenmek için bildirimleri aç.",
  "intro.notificationsTitle": "Hava değişikliklerini kaçırmayın",
  "intro.readyDescription": "Kesin tahminler, gerçek zamanlı hava durumu içgörüleri ve dünya çapındaki istasyon verileri — hepsi güçlü bir uygulamada.",
  "intro.readyTitle": "Hazırsınız!",
  "intro.welcomeDescription": "En iyi hava durumu ajanslarının sağladığı hiper yerel tahminler ve dünya genelindeki 40.000'den fazla hava istasyonuna erişim ile geçmiş ve mevcut gerçek koşulları görün.",
  "intro.welcomeTitle": "Havanız, yeniden tasarlandı",
  "landing.alerts": "Uyarı",
  "landing.alertsDescription": "Kendi uyarılarınızı oluşturun ve tetiklendiği anda bilgilendirin.",
  "landing.featureAlertsDescription": "İlgilendiğiniz koşullar için özel uyarılar ayarlayın—sıcaklık, rüzgar, yağış ve daha fazlası.",
  "landing.featureAlertsTitle": "Akıllı uyarılar",
  "landing.featureAnalyticsDescription": "Etkileşimli grafikler, yan yana karşılaştırmalar ve temel ölçümlerin ötesinde trend analiziyle verilerinize dalın.",
  "landing.featureAnalyticsTitle": "Güçlü analitik",
  "landing.featureExportDescription": "Excel'de analiz, diğer sistemlerle entegrasyon veya yedekleme için verilerinizi CSV formatında indirin.",
  "landing.featureExportTitle": "Her yere dışa aktar",
  "landing.featureForecastDescription": "GFS, ECMWF, ICON ve daha fazlası dahil 10'dan fazla hava modelinden tahminleri karşılaştırarak konumunuz için hangisinin en iyi çalıştığını görün.",
  "landing.featureForecastTitle": "Tahmin karşılaştırması",
  "landing.featureHistoryDescription": "Saatlik, günlük ve aylık ölçekli geçmiş verilere erişin. Araştırma veya kişisel arşivler için CSV'ye aktarın.",
  "landing.featureHistoryTitle": "Zengin geçmiş",
  "landing.featureMultiBrandDescription": "Netatmo, Ecowitt, Ambient Weather, Davis, WeatherFlow ve daha fazlasından istasyonları bağlayın—hepsi tek bir panelde.",
  "landing.featureMultiBrandTitle": "Çoklu marka desteği",
  "landing.featuresSubtitle": "Temel bir hava istasyonu uygulamasından daha fazlasını isteyen hava durumu meraklıları için tasarlandı.",
  "landing.featuresTitle": "Hava durumu analizi için ihtiyacınız olan her şey",
  "landing.finalCtaButton": "Ücretsiz hesap oluşturun",
  "landing.finalCtaSubtitle": "Hava durumu verileri için SmartMixin'e güvenen binlerce hava durumu meraklısına katılın.",
  "landing.finalCtaTitle": "Hava durumu deneyiminizi geliştirmeye hazır mısınız?",
  "landing.forecastDescription": "En iyi hava tahmini modellerinden bazılarına erişin ve havanın ne olacağına dair kendi fikrinizi elde etmek için bunları karşılaştırın.",
  "landing.forecasts": "Tahminler",
  "landing.heroCta": "Ücretsiz başlayın",
  "landing.heroDescription": "Herhangi bir markadan birden fazla hava istasyonunu birleştirin, tahmin modellerini karşılaştırın ve verilerinizi ayrıntılı grafikler ve dışa aktarımlarla analiz edin.",
  "landing.heroSecondaryCta": "Özellikleri görüntüle",
  "landing.heroTagline": "Hava durumu meraklıları için",
  "landing.heroTitle": "Tüm hava durumu verileri. Tek platform.",
  "landing.pricingFeatureAdvancedMetrics": "Gelişmiş metrikler",
  "landing.pricingFeatureAlerts": "Özel uyarılar",
  "landing.pricingFeatureExport": "Veri dışa aktarma (CSV)",
  "landing.pricingFeatureForecastComparison": "Tahmin karşılaştırma",
  "landing.pricingFeatureForecasts": "Tahmin modelleri",
  "landing.pricingFeatureForecastsFreeTier": "1 model",
  "landing.pricingFeatureForecastsPremiumTier": "Tüm modeller (10+)",
  "landing.pricingFeatureReports": "Analizler ve raporlar",
  "landing.pricingFeatureStationComparison": "İstasyon karşılaştırma",
  "landing.pricingFeatureWidgets": "Ana ekran widget'ları",
  "landing.pricingFeatureYearOverYear": "Yıldan yıla analiz",
  "landing.pricingFree": "Ücretsiz",
  "landing.pricingFreeCta": "Başlayın",
  "landing.pricingFreePrice": "0 €",
  "landing.pricingMostPopular": "En popüler",
  "landing.pricingPremium": "Premium",
  "landing.pricingPremiumCta": "Başlayın",
  "landing.pricingPremiumDescription": "Aylık 1,99 €'den başlayan fiyatlarla — web, App Store veya Google Play'den abone olun",
  "landing.pricingSubtitle": "Ücretsiz başlayın, daha fazlasına ihtiyaç duyduğunuzda yükseltin.",
  "landing.pricingTitle": "Basit, şeffaf fiyatlandırma",
  "landing.smartMixinDescription": "SmartMixin, hava istasyonunuza ve dünya çapında 40K+ diğer istasyonlara erişim sağlayan bir uygulamadır. Hava durumu verilerini görmenize ve anlamanıza yardımcı olur.",
  "landing.statBrands": "Desteklenen markalar",
  "landing.statForecasts": "Tahmin modeli",
  "landing.statStations": "Bağlı istasyon",
  "landing.supportedDevices": "Desteklenen cihazlar",
  "landing.supportedDevicesDescription": "Dünya Meteoroloji Örgütü'nden gelen istasyonların üstünde, Smartmixin artan sayıda hava istasyonu markasını desteklemektedir.",
  "landing.supportedDevicesNote": "Ayrıca Dünya Meteoroloji Örgütü'nden 40.000'den fazla kamu istasyonu",
  "landing.supportedDevicesSubtitle": "Önde gelen markalardan hava istasyonlarını bağlayın ve tüm verileri tek bir yerde görün.",
  "landing.supportedDevicesTitle": "İstasyonlarınızla çalışır",
  "landing.thermostatDescription": "Isıtma kalıplarını dış koşullarla karşılaştırmak için Netatmo termostatınızı bağlayın.",
  "landing.thermostatManufacturers": "Termostat üreticileri, ısıtmayı dış mekan koşullarıyla ilişkilendirmek için de desteklenmektedir.",
  "landing.thermostatTitle": "Akıllı ev entegrasyonu",
  "landing.weatherAnalysis": "Hava analizi",
  "landing.weatherAnalysisDescription": "SmartMix, hava durumu verilerini analiz etmenizi sağlayan birçok veri görselleştirme ile birlikte gelir.",
  "landing.weatherAssistant": "Hava Durumu Asistanınız",
  "landing.weatherAssistantDescription": "Mevcut, tarihsel veya tahmin hava koşullarıyla ilgileniyor olun, Smartmixin, ihtiyaç duyduğunuzda çok sayıda bilgi sağlar.",
  "landing.weatherForecastModels": "Hava Tahmin Modelleri",
  "landing.weatherForecastModelsDescription": "Smartmixin, en doğru hava durumu tahmin modellerine erişim sağlar. Tahminlerini kolayca karşılaştırabilir ve kendi fikrinizi yapabilirsiniz.",
  "landing.weatherMap": "Hava durumu haritası",
  "landing.weatherMapDescription": "Haritaya göz atın ve dünyanın herhangi bir yerinde havanın ne olduğunu görselleştirin.",
  "network.cancelError": "İstek iptal edildi",
  "network.connectionError": "Sunucu mevcut değil",
  "network.networkError": "Ağ mevcut değil",
  "network.serverError": "Bir şeyler ters gitti ...",
  "network.timeoutError": "Bağlantı Zaman Aşımı",
  "network.unknownError": "Bilinmeyen hata",
  "providerHints.ambientWeatherApiKey": "ambientweather.net hesap ayarlarınızda oluşturulur.",
  "providerHints.davisApiSecret": "Yalnızca V2 API anahtarını oluşturduğunuzda bir kez gösterilir — güvenli bir yerde saklayın.",
  "providerHints.davisV2ApiKey": "weatherlink.com üzerindeki V2 API anahtarları sayfasından.",
  "providerHints.ecowittApi": "Ecowitt hesabınızın API sayfasından.",
  "providerHints.ecowittApp": "Uygulama anahtarı, yine Ecowitt hesabınızdan.",
  "providerHints.myAcuriteCredentialsBanner": "My AcuRite hesabınızın e-posta ve şifresini kullanın — SmartMixin girişini değil.",
  "providerHints.myAcuriteEmail": "My AcuRite hesabınızın e-postası — SmartMixin girişiniz değil.",
  "providerHints.myAcuritePassword": "My AcuRite hesabınızın şifresi.",
  "providerHints.weatherflowToken": "tempestwx.com → ayarlar → veri yetkilerinden kişisel kullanım belirteci.",
  "providerHints.wundergroundEditKey": "Başka bir anahtar kullan",
  "providerHints.wundergroundKey": "Weather Underground hesabınızın API anahtarları sayfasından alınan uzun bir dizi — wunderground.com şifreniz değil.",
  "providerHints.wundergroundKeyExample": "örn. 5f6a7b8c9dabcdef…",
  "providerHints.wundergroundKeyVerified": "API anahtarı doğrulandı",
  "providerHints.wundergroundKeyVerifying": "Anahtar doğrulanıyor…",
  "providerHints.wundergroundNoStationsNearby": "Bu konumun yakınında istasyon bulunamadı. Doğrudan bir istasyon kimliği girmeyi deneyin.",
  "providerHints.wundergroundStationId": "Herhangi bir Weather Underground istasyon kimliği — sizinki veya yakınınızdaki bir kamuya açık istasyon.",
  "providerHints.wundergroundStationIdExample": "örn. KCASANFR123",
  "providerIntro.ambientWeatherStep2": "Ambient Weather API anahtarınızı alın.",
  "providerIntro.davisStep2": "Davis V2 API anahtarınızı ve API gizli anahtarınızı alın.",
  "providerIntro.ecowittStep2": "Ecowitt API anahtarı ve Uygulama anahtarınızı alın.",
  "providerIntro.getStarted": "Başla",
  "providerIntro.myAcuriteStep2": "Mevcut My AcuRite hesabınızın e-posta ve şifresini kullanın.",
  "providerIntro.netatmoEnergyStep2": "İstendiğinde Netatmo'ya giriş yapın — API anahtarı gerekmez.",
  "providerIntro.netatmoWeatherStep2": "İstendiğinde Netatmo'ya giriş yapın — API anahtarı gerekmez.",
  "providerIntro.signupBanner": "Neredeyse tamam — {provider} bağlantısı kurmak için ücretsiz SmartMixin hesabınızı oluşturun.",
  "providerIntro.step1": "SmartMixin hesabınızda oturum açın ({provider} girişinizde DEĞİL).",
  "providerIntro.step3EmailPassword": "Buraya girin.",
  "providerIntro.step3KeyOrToken": "Buraya yapıştırın.",
  "providerIntro.step3OAuth": "Açılan pencerede SmartMixin'i yetkilendirin.",
  "providerIntro.step3Wunderground": "API anahtarınızı yapıştırın, ardından yakındaki bir istasyonu seçin veya herhangi bir istasyon kimliği girin.",
  "providerIntro.title": "{provider} bağlantısı",
  "providerIntro.weatherflowStep2": "Kişisel kullanım Tempest belirtecinizi alın.",
  "providerIntro.wundergroundBrowsePublic": "İstasyonunuz yok mu? Kamuya açık olanlara göz atın",
  "providerIntro.wundergroundFindNearby": "Yakınımdaki istasyonları bul",
  "providerIntro.wundergroundOrEnterId": "Veya bir istasyon kimliği girin",
  "providerIntro.wundergroundStep2": "Weather Underground API anahtarınızı alın. Daha sonra herhangi bir istasyona bağlanabilirsiniz — kendinize ait veya kamuya açık.",
  "reports.agroMeteorology": "Agrometeoroloji",
  "reports.analysis": "Analiz",
  "reports.annualCumulativeRainfallComparison": "Yıllık Kümülatif Yağış Karşılaştırması",
  "reports.annualHeatingDurationComparison": "Yıllık ısıtma süresi karşılaştırması",
  "reports.annualHeatingEfficiency": "Yıllık Isıtma Verimliliği",
  "reports.annualIndoorComparison": "Yıllık İç Mekan Karşılaştırması",
  "reports.annualIndoorReport": "Yıllık İç Mekan Raporu",
  "reports.annualOutdoorComparison": "Yıllık dış mekan karşılaştırması",
  "reports.annualOutdoorReport": "Yıllık Açık Hava Raporu",
  "reports.annualReport": "Yıllık Rapor",
  "reports.annualSolarReport": "Yıllık Güneş Raporu",
  "reports.annualWaterBalance": "Yıllık Su Dengesi",
  "reports.annualWaterBalanceCarryOver": "Önceki yıldan devret",
  "reports.annualWaterBalanceDescription": "Su dengesi (basitleştirilmiş versiyon, sadece yağmur ve buharlaştırma hızı kullanılır) su kaynağını yönetmeye yardımcı olur",
  "reports.avgHumidity": "Ortalama nem",
  "reports.avgMaxTemperature": "Ortalama t ° maks.",
  "reports.avgMetric": "Ortalama {metric}",
  "reports.avgMinTemperature": "Ortalama t ° dk",
  "reports.avgPressure": "Ortalama basınç",
  "reports.avgTemperature": "Ortalama sıcaklık",
  "reports.comfortable": "Rahat (% 45 {lessThan} nem ≤% 60)",
  "reports.cumulativeRainfall": "Kümülatif yağış",
  "reports.cumulativeRainfallDescription": "Seçilen dönem boyunca biriken toplam yağışı takip edin.",
  "reports.dailyMaxRainfall": "Günlük Max. yağış",
  "reports.dataExport": "Dışa aktarma verileri",
  "reports.dataExportXlsxFormatDescription": "İstasyonunuzun tüm verilerini Excel formatında (*.xlsx) dışa aktarın. Düğmeye tıkladıktan sonra, birkaç dakika sonra işlenmiş verilerle bir e -posta alırsınız.",
  "reports.daysWithFrost": "Donlu günler",
  "reports.daysWithoutThaw": "Çözülmeden günler",
  "reports.daysWithStrongFrost": "Güçlü donlu günler",
  "reports.emailSent": "Posta kutunuza bir e -posta gönderildi",
  "reports.grasslandTemperatureSum": "Otlak sıcaklığı toplamı",
  "reports.grasslandTemperatureSumDescription": "İlkbaharda {threshold} toplamı aşılırsa, bitki örtüsünün sürdürülebilir başlangıcına ulaşıldı (Avrupa'da çalışır)",
  "reports.growingDegreeDays": "Büyüme derece günleri",
  "reports.highPressure": "Antisiklon (ortalama basınç ≥ 1013Mbar)",
  "reports.indoorReport": "İç mekan raporu",
  "reports.keyFacts": "Anahtar Gerçekler",
  "reports.longestRunOfRainyDays": "Yağmurlu günlerin en uzun koşusu",
  "reports.longestRunWithoutRun": "Yağmur olmadan en uzun koşu",
  "reports.lowPressure": "Düşük basınç (ortalama basınç {lessThan} 1013 mbar)",
  "reports.maxHumidity": "Maksimum nem",
  "reports.maxMetric": "Maksimum {metric}",
  "reports.maxPressure": "Maksimum basınç",
  "reports.maxPressureMagnitude24h": "Maksimum büyüklük (/24 saat)",
  "reports.maxTemperature": "Maksimum sıcaklık",
  "reports.maxTempGreaterThan": "T ° maks.",
  "reports.maxTempMagnitude24h": "Maksimum büyüklük (/24 saat)",
  "reports.minHumidity": "Minimum nem",
  "reports.minMetric": "Minimum {metric}",
  "reports.minPressure": "Minimum basınç",
  "reports.minPressureMagnitude24h": "Minimum büyüklük (/24 saat)",
  "reports.minTemperature": "Minimum sıcaklık",
  "reports.minTempMagnitude24h": "Minimum büyüklük (/24 saat)",
  "reports.monthlyHeatingEfficiency": "Aylık ısıtma verimliliği",
  "reports.monthlyIndoorReport": "Aylık İç Mekan Raporu",
  "reports.monthlyOutdoorReport": "Aylık dış mekan raporu",
  "reports.monthlyReport": "Aylık Rapor",
  "reports.monthlySolarReport": "Aylık Güneş Raporu",
  "reports.monthlyWindReport": "Aylık Rüzgar Raporu",
  "reports.numberOfDays": "Gün sayısı",
  "reports.outdoorReport": "Açık hava raporu",
  "reports.rainfall": "Yağış",
  "reports.rainyDays": "Yağmurlu Günler",
  "reports.relativelyWet": "Nispeten ıslak (% 60 {lessThan} nem ≤% 80)",
  "reports.sendEmail": "E -posta Gönder",
  "reports.tooDry": "Çok kuru (nem ≤%45)",
  "reports.tooWet": "Çok ıslak (nem {greaterThan}%80)",
  "reports.tropicalNights": "Tropik Geceler",
  "reports.waterBalance": "Su dengesi",
  "reports.yearToDateTemperature": "Yılbaşı sıcaklığı",
  "reports.yearToDateTemperatureComparison": "Yılbaşı sıcaklık karşılaştırması",
  "sensors.aqiByChannel": "Kanala göre AQI",
  "sensors.bgtSensors": "Siyah küre ve WBGT",
  "sensors.cameraFeed": "Kamera",
  "sensors.compareAqi": "AQI karşılaştır",
  "sensors.compareHumidity": "Nemi karşılaştır",
  "sensors.compareMoisture": "Toprak nemini karşılaştır",
  "sensors.comparePm25": "PM2.5 karşılaştır",
  "sensors.compareTemperatures": "Sıcaklıkları karşılaştır",
  "sensors.depthByChannel": "Kanala göre derinlik",
  "sensors.heatStressExtreme": "Aşırı ısı stresi",
  "sensors.heatStressModerate": "Orta düzey ısı stresi",
  "sensors.heatStressNone": "Isı stresi yok",
  "sensors.heatStressStrong": "Güçlü ısı stresi",
  "sensors.heatStressVeryStrong": "Çok güçlü ısı stresi",
  "sensors.humidityByChannel": "Kanala göre nem",
  "sensors.indoorAirQuality": "İç mekan hava kalitesi",
  "sensors.indoorAirQualityPm": "PM2.5 ve PM10 AQI",
  "sensors.indoorClimate": "İç ortam iklimi",
  "sensors.indoorCo2Levels": "CO2 seviyeleri",
  "sensors.indoorTemperatureAndHumidity": "Sıcaklık ve nem",
  "sensors.last24Hours": "24 saat",
  "sensors.last30Days": "30 gün",
  "sensors.last7Days": "7 gün",
  "sensors.leafTemperatureByChannel": "Kanala göre yaprak sıcaklığı",
  "sensors.leafWetnessByChannel": "Kanala göre yaprak nemi",
  "sensors.lightningSensor": "Yıldırım",
  "sensors.moistureByChannel": "Kanala göre toprak nemi",
  "sensors.noDataAvailable": "Veri mevcut değil",
  "sensors.pm10AndAqi": "PM10 & AQI",
  "sensors.pm1AndAqi": "PM1.0 & AQI",
  "sensors.pm25AndAqi": "PM2.5 & AQI",
  "sensors.pm25ByChannel": "Kanala göre PM2.5",
  "sensors.pm4AndAqi": "PM4.0 & AQI",
  "sensors.selectChannel": "Kanal seçin",
  "sensors.sensorDetailDescription": "Sensör kanallarınızın geçmiş verilerini ve eğilimlerini görüntüleyin.",
  "sensors.sensorHistory": "Sensör geçmişi",
  "sensors.soilConductivityByChannel": "Kanala göre iletkenlik",
  "sensors.soilTemperatureByChannel": "Kanala göre toprak sıcaklığı",
  "sensors.strikesToday": "Bugün düşen yıldırım",
  "sensors.temperatureByChannel": "Kanala göre sıcaklık",
  "sensors.viewChart": "Grafiği görüntüle",
  "settings.about": "Hakkında",
  "settings.aboutDescription": "Lisans Sözleşmesi, Gizlilik Politikası",
  "settings.account": "Hesap",
  "settings.accountDescription": "Profil, şifre değişikliği",
  "settings.accountIntro": "Veriler hesabınızla ilgilidir:",
  "settings.accountSection": "Hesap",
  "settings.appearance": "Görünüm",
  "settings.appearanceDescription": "Tema ve görüntüleme seçenekleri",
  "settings.appVersion": "SmartMixin v{version}",
  "settings.arabic": "Arapça",
  "settings.availableServices": "Mevcut",
  "settings.bulgarian": "Bulgarca",
  "settings.cannotDisconnectLastAccount": "Tek giriş yönteminizin bağlantısı kesilemez. Lütfen önce başka bir giriş yöntemi ekleyin.",
  "settings.catalan": "Katalanca",
  "settings.changeEmail": "E-postayı değiştir",
  "settings.changePassword": "Şifre değiştir",
  "settings.chartGestures": "Grafiklerde jestler",
  "settings.chartGesturesDescription": "Grafiklerde kaydırma zaman periyodunu değiştirir, Grafikler Sıkıştırma Değiştirme Zaman Ölçeği",
  "settings.connect": "Bağla",
  "settings.connected": "Bağlı",
  "settings.connectedAccounts": "Bağlı hesaplar",
  "settings.connectedAccountsDescription": "Apple, Google, Facebook",
  "settings.connectedServices": "Bağlı",
  "settings.connectedSince": "{date} tarihinden beri bağlı",
  "settings.connectionSuccess": "{provider} hesabı başarıyla bağlandı",
  "settings.contactUs": "Bize ulaşın",
  "settings.contactUsDescription": "Yardım alın veya geri bildirim gönderin",
  "settings.croatian": "Hırvatça",
  "settings.currentPassword": "Mevcut şifre",
  "settings.czech": "Çekçe",
  "settings.danish": "Danca",
  "settings.dark": "Karanlık tema",
  "settings.dataDisplay": "Veri görüntüleme",
  "settings.dateAndTime": "Tarih ve saat",
  "settings.disconnect": "Bağlantıyı kes",
  "settings.disconnectConfirmation": "{provider} hesabınızın bağlantısını kesmek istediğinizden emin misiniz?",
  "settings.disconnectionSuccess": "{provider} hesabının bağlantısı başarıyla kesildi",
  "settings.donateButton": "Bağış yapın",
  "settings.donateDescription": "SmartMixin küçük bir ekip tarafından geliştiriliyor. Faydalı buluyorsanız, dilediğiniz tutarda tek seferlik bir bağışla gelişimine destek olabilirsiniz. Bu bir hediyedir — planınızı değiştirmez ve herhangi bir özelliği açmaz.",
  "settings.donateSuccessBody": "Bağışınız, SmartMixin'in çalışmaya ve gelişmeye devam etmesine yardımcı olur. İçtenlikle minnettarız.",
  "settings.donateSuccessTitle": "Desteğiniz için teşekkürler!",
  "settings.donateTitle": "SmartMixin'e destek olun",
  "settings.dutch": "Flemenkçe",
  "settings.emailChange": "E-posta adresini değiştir",
  "settings.emailChangeConfirmation": "E-posta değişikliği onayı",
  "settings.emailChangeFailure": "E-posta değişiklik bağlantısı geçersiz veya süresi dolmuş.",
  "settings.emailChangeSuccess": "E-postanız başarıyla {newEmail} olarak değiştirildi.",
  "settings.emailChangeVerificationSent": "Yeni e-posta adresinize bir doğrulama e-postası gönderildi. Lütfen gelen kutunuzu kontrol edin ve değişikliği onaylamak için bağlantıya tıklayın.",
  "settings.english": "İngilizce",
  "settings.forecastModelOrderEmpty": "Kayıtlı sıralama yok — varsayılan olarak GFS'yi kullanıyoruz.",
  "settings.forecastModelOrderFreeHint": "Premium modeller, SmartMixin Premium aboneliği gerektirir.",
  "settings.forecastModelOrderHelp": "Listendeki, her istasyonu kapsayan ilk modeli seçiyoruz.",
  "settings.forecastModelOrderReset": "Varsayılana dön",
  "settings.forecastModelOrderTitle": "Varsayılan tahmin modeli",
  "settings.forecastModels": "Tahmin modelleri",
  "settings.forecastModelsDescription": "Tercihe göre sırala",
  "settings.french": "Fransızca",
  "settings.german": "Almanca",
  "settings.gestures": "Jestler",
  "settings.greek": "Yunanca",
  "settings.helpCenter": "Yardım Merkezi",
  "settings.helpCenterDescription": "SSS ve kılavuzlar",
  "settings.hungarian": "Macarca",
  "settings.integrationsSection": "Entegrasyonlar",
  "settings.italian": "İtalyanca",
  "settings.japanese": "Japonca",
  "settings.korean": "Korece",
  "settings.language": "Dil",
  "settings.languageDescription": "Tercih edilen dil",
  "settings.light": "Işık Teması",
  "settings.newEmailAddress": "Yeni e-posta adresi",
  "settings.newPassword": "Yeni Şifre",
  "settings.newPasswordAgain": "Yine yeni şifre",
  "settings.norwegian": "Norveççe",
  "settings.notConnected": "Bağlı değil",
  "settings.notificationsSection": "Bildirimler",
  "settings.oldPassword": "Eski Şifre",
  "settings.ongoingNotificationEnabled": "Kalıcı bildirimi etkinleştir",
  "settings.ongoingNotificationMetrics": "Gösterilen ölçümler",
  "settings.ongoingNotificationMetricsHint": "Seçili ölçümleri yeniden sıralamak için sürükleyin",
  "settings.ongoingNotificationPermissionRequired": "Bildirim izni gerekli",
  "settings.ongoingNotificationStation": "Meteoroloji istasyonu",
  "settings.passwordChange": "Şifre Değişikliği",
  "settings.polish": "Lehçe",
  "settings.portuguese": "Portekizce",
  "settings.preferencesSection": "Tercihler",
  "settings.premium": "Premium",
  "settings.premiumActive": "Aktif",
  "settings.premiumAnnualThenPrice": "Ardından 9,99 €/yıl",
  "settings.premiumAnnualTrialInfo": "{days} günlük ücretsiz deneme ile başlayın",
  "settings.premiumCurrentPlan": "Mevcut Plan",
  "settings.premiumDescription": "Premium özelliklerin kilidini aç",
  "settings.premiumDownloadApp": "Abone olmak için uygulamayı indirin:",
  "settings.premiumExpiresOn": "{date} tarihinde yenilenir",
  "settings.premiumFreePlan": "Ücretsiz",
  "settings.premiumInactive": "Abone değil",
  "settings.premiumManageWebSubscription": "Aboneliğinizi yönetin, ödeme yöntemini güncelleyin veya iptal edin.",
  "settings.premiumPremiumPlan": "Premium",
  "settings.premiumSubscribeAnnual": "Yıllık — 9,99 €/yıl",
  "settings.premiumSubscribedOn": "{platform} üzerinden abone olundu",
  "settings.premiumSubscribeMonthly": "Aylık — 1,99 €/ay",
  "settings.premiumSubscribeOnWeb": "Tüm premium özelliklerin kilidini açmak için şimdi abone olun.",
  "settings.premiumSubscriptionSuccess": "Aboneliğiniz etkinleştirildi! Tüm premium özelliklerin keyfini çıkarın.",
  "settings.premiumSubscriptionSuccessTitle": "Premium'a hoş geldiniz!",
  "settings.premiumWebappNotice": "Abonelikler yalnızca iOS veya Android'deki SmartMixin mobil uygulaması üzerinden satın alınabilir.",
  "settings.privacyPolicy": "Gizlilik Politikası",
  "settings.profile": "Profil",
  "settings.russian": "Rusça",
  "settings.serbian": "Sırpça",
  "settings.settings": "Ayarlar",
  "settings.slovak": "Slovakça",
  "settings.smallDecimals": "Küçük ondalıklar",
  "settings.smallDecimalsDescription": "Ondalık basamakları daha küçük boyutta göster",
  "settings.socialConnectionsIntro": "Hızlı giriş için sosyal hesaplarınızı bağlayın. Hesapları istediğiniz zaman bağlayabilir veya bağlantısını kesebilirsiniz.",
  "settings.spanish": "İspanyolca",
  "settings.statusBarWidget": "Durum çubuğu widget'ı",
  "settings.statusBarWidgetDescription": "Her zaman görünür hava verileri",
  "settings.subscriptionSection": "Abonelik",
  "settings.supportSection": "Destek",
  "settings.swedish": "İsveççe",
  "settings.systemTheme": "Sistem teması",
  "settings.termsOfService": "Hizmet Şartları",
  "settings.turkish": "Türkçe",
  "settings.ukrainian": "Ukraynaca",
  "settings.units": "Birimler",
  "settings.unitsDescription": "Uygulamada görüntülenen ölçüm birimleri",
  "settings.update": "Güncelleme",
  "settings.updateYourProfile": "Profilinizi güncelleyin",
  "settings.weatherServices": "Hava durumu servisleri",
  "settings.weatherServicesConnected": "{count, plural, =0 {Bağlı hizmet yok} one {# hizmet bağlı} other {# hizmet bağlı}}",
  "settings.weatherServicesDescription": "Netatmo, Davis, Weatherflow ve diğerlerini bağlayın",
  "settings.windDirectionConvention": "Rüzgâr yönü oku",
  "settings.windDirectionConventionDescription": "Rüzgâr yönü oklarının nasıl görüntüleneceğini seçin",
  "settings.windDirectionMeteorological": "Kaynak yönü",
  "settings.windDirectionMeteorologicalDescription": "Ok, rüzgârın nereden geldiğini gösterir (meteorolojik uzlaşım)",
  "settings.windDirectionOceanographic": "Akış yönü",
  "settings.windDirectionOceanographicDescription": "Ok, rüzgârın nereye estiğini gösterir (oşinografik uzlaşım)",
  "units.absolutePressure": "Mutlak basınç",
  "units.airDensity": "Hava yoğunluğu",
  "units.airGap": "Hava boşluğu",
  "units.apparentTemperature": "Hissedilen sıcaklık",
  "units.AQI": "AQI",
  "units.AQI_24H": "24h AQI",
  "units.avg": "AVG.",
  "units.beaufort": "Beaufort",
  "units.blackGlobeTemperature": "Siyah küre sıcaklığı",
  "units.boilerOn": "Kazan",
  "units.co2": "CO2",
  "units.conductivity": "İletkenlik",
  "units.coolingDegreeDays": "Soğutma Derecesi Günleri",
  "units.dailyHeatingDuration": "Günlük ısıtma süresi",
  "units.dailyPrecipitation": "Günlük yağış",
  "units.dailyRain": "Günlük yağış",
  "units.degreeDay": "Derece Günü",
  "units.degreeDayShort": "DD",
  "units.depth": "Derinlik",
  "units.depthSensors": "Derinlik sensörleri",
  "units.dewPoint": "Çiy noktası",
  "units.distance": "Mesafe",
  "units.downTrend": "aşağı",
  "units.E": "E",
  "units.E_long": "Doğu",
  "units.ENE": "ENE",
  "units.ENE_long": "Doğu-kuzeydoğu",
  "units.ESE": "ESE",
  "units.ESE_long": "Doğu-güneydoğu",
  "units.ET": "Evapotranspirasyon",
  "units.ETshort": "ET",
  "units.feelLike": "Hissettiren",
  "units.feelsLike": "Hissettiren",
  "units.footMile": "Ayak, mil",
  "units.frostPoint": "Donma noktası",
  "units.gust": "Rüzgar hamlesi",
  "units.heatIndex": "Isı indeksi",
  "units.heatingDegreeDays": "Isıtma Derece Günleri",
  "units.heatingPower": "Isıtma gücü",
  "units.humidex": "Humidex",
  "units.humidity": "Nem",
  "units.inch": "İnç",
  "units.inchOfMercury": "İnç cıva",
  "units.kilometerPerHour": "Saatte kilometre",
  "units.knot": "Düğüm",
  "units.last12Hours": "Son 12 saat",
  "units.last24Hours": "Son 24 saat",
  "units.last3Hours": "Son 3 saat",
  "units.last6Hours": "Son 6 saat",
  "units.lastHour": "Son saat",
  "units.lastLightningImpact": "Son etki",
  "units.lastMeasure": "Son önlem",
  "units.leafSensors": "Yaprak sensörleri",
  "units.leafWetness": "Yaprak ıslaklık",
  "units.lightningDistance": "Mesafe",
  "units.lightningStrikeCount": "Yıldırım çarpması sayısı",
  "units.lightningStrikeDistance": "Yıldırım çarpması mesafesi",
  "units.max": "Maks.",
  "units.max_gust": "Maks. rüzgar hamlesi",
  "units.max_wind": "Maks. rüzgâr",
  "units.meterKilometer": "Metre, kilometre",
  "units.meterPerSecond": "Saniyede metre",
  "units.milePerHour": "Saatte mil",
  "units.millibar": "Milibar",
  "units.millimeter": "Milimetre",
  "units.millimeterOfMercury": "Milimetre cıva",
  "units.min": "Min.",
  "units.N": "N",
  "units.N_long": "Kuzey",
  "units.NE": "NE",
  "units.NE_long": "Kuzeydoğu",
  "units.NNE": "Nne",
  "units.NNE_long": "Kuzey-kuzeydoğu",
  "units.NNW": "NNW",
  "units.NNW_long": "Kuzey-kuzeybatı",
  "units.noise": "Gürültü",
  "units.normalizedHeatingCoefficient": "Normalleştirilmiş ısıtma katsayısı",
  "units.NW": "KB",
  "units.NW_long": "Kuzeybatı",
  "units.O3": "Ozon",
  "units.PM_1": "PM1",
  "units.PM_10": "PM10",
  "units.PM_2P5": "PM2.5",
  "units.precipitation": "Yağış",
  "units.pressure": "Basınç",
  "units.rain": "Yağmur",
  "units.rainRate": "Yağış yoğunluğu",
  "units.referenceTemperature": "Referans sıcaklığı",
  "units.relativePressure": "Göreceli basınç",
  "units.S": "S",
  "units.S_long": "Güney",
  "units.SE": "Se",
  "units.SE_long": "Güneydoğu",
  "units.setPoint": "Ayar noktası",
  "units.snow": "Kar",
  "units.snowfall": "Kar yağışı",
  "units.soilMoisture": "Nem",
  "units.soilSensors": "Toprak sensörleri",
  "units.solarEnergy": "Güneş enerjisi",
  "units.solarRadiation": "Güneş radyasyonu",
  "units.speed": "Hız",
  "units.SSE": "SSE",
  "units.SSE_long": "Güney-güneydoğu",
  "units.SSW": "SSW",
  "units.SSW_long": "Güney-güneybatı",
  "units.stableTrend": "stabil",
  "units.sum": "Toplam",
  "units.SW": "Sw",
  "units.SW_long": "Güneybatı",
  "units.temperature": "Sıcaklık",
  "units.temperatureAndHumiditySensors": "Sıcaklık ve Nem Sensörleri",
  "units.temperatureSensors": "Sıcaklık ve Nem Sensörleri",
  "units.thsw": "THSW",
  "units.thw": "THW",
  "units.today": "Bugün",
  "units.upTrend": "yukarı",
  "units.uv": "UV",
  "units.visibility": "Görünürlük",
  "units.W": "W",
  "units.W_long": "Batı",
  "units.wetBulbGlobeTemperature": "Islak küre sıcaklığı",
  "units.wetBulbTemperature": "Yaş termometre sıcaklığı",
  "units.wind": "Rüzgâr",
  "units.windChill": "Rüzgar Soğutma",
  "units.windDirection": "Rüzgâr yönü",
  "units.windRun": "Rüzgar Koşusu",
  "units.windRunDescription": "Rüzgar koşusu, seyahat edilen rüzgarın bir süre boyunca toplam mesafesidir",
  "units.WNW": "WNW",
  "units.WNW_long": "Batı-Kuzeybatı",
  "units.WSW": "WSW",
  "units.WSW_long": "Batı-güneybatı"
}
